import React, { useEffect, useState } from 'react'
import seqStore from '../../store/seqStore'

export default function SequenceIcon() {
    const currentTrack = seqStore((state) => state.settings.currentTrack)

    const [fillColour, setFillColour] = useState('#FFB72C')

    useEffect(() =>{
        switch(currentTrack) {
            case 0:
                setFillColour('#FFB72C')
                break
            case 1:
                setFillColour('#FC4B4B')
                break
            case 2:
                setFillColour('#47BE61')
                break
            case 3:
                setFillColour('#1A8DF8')
                break
            default: setFillColour('#FFB72C')
        }
    }, [currentTrack])

    return (
        <svg width="29" height="12" viewBox="0 0 29 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="0.320129" width="6.92785" height="11.3597" rx="1.08188" fill={fillColour}/>
            <rect x="10.9279" y="0.320129" width="6.92785" height="11.3597" rx="1.08188" fill={fillColour}/>
            <rect x="21.8557" y="0.320129" width="6.92785" height="11.3597" rx="1.08188" fill={fillColour}/>
        </svg>


    )
}
